<template>
  <div class="flex-grow-1 d-flex flex-column overflow-y-hidden">
    <div class="a-header">
      <span class="a-header--title slide-down-enter-active">View Notification History</span>
    </div>
    <div class="d-flex justify-content-center align-items-center pt-35-px" v-if="isLoading">
      <Spinner />
    </div>
    <transition name="slide-up">
      <div class="a-filter" v-if="!isLoading">
        <a-row class="full-w" type="flex" justify="start" :gutter="16">
          <a-col :span="5">
            <div class="full-w a-input-group" :class="{ active: !!filterParams.search }">
              <a-button size="large">
                <a-icon type="search" />
              </a-button>
              <a-input placeholder="Search" @change="onSearch">
                <a-icon slot="suffix" class="custom-suffix" type="loading" spin v-show="isSearching" />
              </a-input>
            </div>
          </a-col>
        </a-row>
      </div>
    </transition>
    <div v-resize="elSizeChange" class="a-body flex-grow-1 overflow-y-hidden">
      <transition name="slide-up">
        <template v-if="!isLoading">
          <PaginationTable
            :clientPaging="false"
            :pagination="pagin"
            :columns="NotificationHistoryColumn"
            :dataSource="data"
            :tableSize="tableSize">
            <template slot="email" slot-scope="{ record }">
              <a-tooltip>
                <template slot="title">
                  {{ record.email }}
                </template>
                <p class="mb-0 d-block text-truncate">
                  {{ record.email }}
                </p>
              </a-tooltip>
            </template>
            <template slot="url" slot-scope="{ record }">
              <a :href="record.url" class="url d-block text-truncate">{{ record.url }}</a>
            </template>
            <template slot="date_sent" slot-scope="{ record }">
              <div>
                <p class="mb-0">
                  <time>{{ record.date_sent | dateString }}</time>
                  <br />
                  <time>{{ record.date_sent | timeString }}</time>
                </p>
              </div>
            </template>
            <div slot="notification_type_name" slot-scope="{ record }">
              {{ record.notification_type_name }}
            </div>
          </PaginationTable>
        </template>
      </transition>
    </div>
    <div class="a-footer">
      <PaginationBar :pageSize.sync="pagin.pageSize" :total="pagin.total" @change="paginChange" />
    </div>
  </div>
</template>

<script>
  import { debounce } from 'lodash';
  import { PAGE_OPTIONS } from '@constants/pageOptions';
  import { NOTIFICATION_TYPES } from '@constants/notifications';
  import { NotificationHistoryColumn } from '../columnsTable/NotificationHistoryListColumn';
  import NotificationService from '../services/notification.service';

  export default {
    name: 'NotificationHistory',
    data() {
      let pageSize = Number(window.localStorage.getItem("pageSize"));
      if(!pageSize) {
          pageSize = 5;
      }

      return {
        PAGE_OPTIONS,
        NOTIFICATION_TYPES,
        NotificationHistoryColumn,
        data: [],
        filterParams: {
          search: ''
        },
        pagin: {
          current: 1,
          pageSize: pageSize,
          total: 0
        },
        isSearching: false,
        isLoading: true,
        tableSize: {
          height: '',
          width: ''
        }
      };
    },
    mounted() {
      this.getHistory();
    },
    methods: {
      onSearch: debounce(function (inputChangeEvent) {
        const inputSearchValue = inputChangeEvent.target.value;
        this.filterParams.search = inputSearchValue && String(inputSearchValue).trim().toLowerCase();
        this.getHistory();
      }, 800),
      paginChange(pagin) {
        this.pagin = { ...pagin };
        this.getHistory();
      },
      async getHistory() {
        try {
          this.isSearching = true;
          const response = await NotificationService.getHistory(this.pagin, this.filterParams.search);
          this.data = (response.data || []).map((item, index) => {
            const sms = item.sms ? `(+65) ${item.sms}` : null
            const notification_type_name = NOTIFICATION_TYPES.find((type) => {
              return type.id == item.type;
            }).name;
            return {
              ...item,
              sms,
              notification_type_name,
              index: index + response.from,
              
            };
          });
          this.isSearching = false;
          this.pagin.total = response.total;
        } catch {
          this.$showErrorMessage('HTTP error received from web server.!');
        } finally {
          if (this.isLoading) {
            setTimeout(() => {
              this.isLoading = false;
            }, 300);
          }
        }
      },
      elSizeChange(size) {
        this.tableSize = size;
      }
    }
  };
</script>

<style lang="scss" scoped>
  .custom-suffix {
    font-size: 20px;
    color: #20a4b8;
  }
</style>
